module.exports = require("lodash.isboolean");